var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBillingActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.16921 18.059C6.92087 17.2523 8.06671 17.3165 8.72671 18.1965L9.65254 19.434C10.395 20.4148 11.5959 20.4148 12.3384 19.434L13.2642 18.1965C13.9242 17.3165 15.07 17.2523 15.8217 18.059C17.4534 19.8007 18.7825 19.2231 18.7825 16.7848V6.45398C18.7917 2.75982 17.93 1.83398 14.465 1.83398H7.53504C4.07004 1.83398 3.20837 2.75982 3.20837 6.45398V16.7756C3.20837 19.2231 4.54671 19.7915 6.16921 18.059Z",
    stroke: "#5348EC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33337 6.41602H14.6667",
    stroke: "#5348EC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 10.084H13.75",
    stroke: "#5348EC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBillingActive);
export default __webpack_public_path__ + "static/media/ic_billing_active.95cd5ffe2b8aee7b9f2fa133da10d9a1.svg";
export { ForwardRef as ReactComponent };